import { getDefaultShopConfig } from './default';
import { Conditions, getConditionsFilterConfig } from '../filters/condition';
import * as custom from '../filters/marketplace-custom-config';
import { getColorFilterConfig } from '../filters/color';

const outnaboutConditions = [
  {
    key: Conditions.Excellent,
    label: 'Like New',
    shortLabel: 'Like New',
    description: 'No scratches or damage to fabric. Clean and looks new.',
  },
  {
    key: Conditions.Good,
    label: 'Good',
    shortLabel: 'Good',
    description:
      'Small scratches to frame and footplate, but overall clean and in great working condition.',
  },
  {
    key: Conditions.MinorDefect,
    label: 'Worn',
    shortLabel: 'Worn',
    description:
      'Scratches to frame and/or footplate and handlebars, but fabrics are intact and wheels don’t wobble, brake bar works, fold works.',
  },
];

export const outnaboutShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig({ options: outnaboutConditions }),
    getColorFilterConfig(),
  ],
};
